import { __, prop } from 'ramda';

const PRISMIC_FORMAT = {
  Portrait: 'portrait',
  Paysage: 'landscape',
};

export const toFormat = prop(__, PRISMIC_FORMAT);
